// src/pages/CalculatorFields.js
//
// Shared field primitives for calculator steps 2-4.
// Matches .profile-field-label / .profile-input / .profile-select /
// .profile-field-helper from ProfilePage.js — same visual language.
//
// `warning` (Field) and `onBlur` (NumberField) are optional — both default
// to no-ops, so every existing call site is unaffected. Added together for
// the income-amount period-mismatch nudge in IncomeCard.js: warning is
// distinct from helper because it's conditional/transient (shown after
// blur, based on entered value) where helper is static, always-on guidance.

import React from 'react'

export function Field({ label, helper, warning, children }) {
  return (
    <label className="block">
      <div className="u-form-label">{label}</div>
      {children}
      {helper && <div className="profile-field-helper">{helper}</div>}
      {warning && <div className="cal-field-warning">{warning}</div>}
    </label>
  )
}

export function Select({ value, onChange, options, placeholder = '— select —' }) {
  return (
    <select className="profile-select" value={value ?? ''} onChange={e => onChange(e.target.value)}>
      <option value="">{placeholder}</option>
      {options.map(o => (
        <option key={String(o.value)} value={o.value}>{o.label}</option>
      ))}
    </select>
  )
}

export function NumberField({ value, onChange, onBlur, placeholder, max }) {
  return (
    <input
      type="number"
      className="profile-input"
      value={value ?? ''}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
      placeholder={placeholder || '0'}
      min="0"
      max={max}
    />
  )
}